import { render, staticRenderFns } from "./AddPeople.vue?vue&type=template&id=9d955b20"
import script from "./AddPeople.vue?vue&type=script&lang=js"
export * from "./AddPeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports